import { axiosService } from '@/services/AxiosService';
import PermissionService from './PermissionService';

/**
 * @typedef {Object} User
 * @property {number} id
 * @property {string} name
 * @property {string} email
 * @property {number} role_id
 */

/**
 * @typedef {Object} Notification
 * @property {number} id
 * @property {string} name
 * @property {boolean} is_read
 * @property {number} notification_category_id
 * @property {number} horse_id
 * @property {number} user_id
 * @property {date} created
 * @property {date} modified
 */

/**
 * Servizio per gestire le informazioni dell'utente.
 */
class UserService {
	constructor() {
		this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
	}

	/**
	 * Ottieni le informazioni dell'utente.
	 * @returns {Promise<User>} I dati utente.
	 * @throws {Error} Se la richiesta fallisce.
	 */
	async getInfo() {
		try {
			const response = await this.axiosInstance.get('/users/getInfo');

			if (response.status !== 200) {
				throw new Error('Failed to fetch user info');
			}

			/** @type {User} */
			const userData = response.data.data.user;
			//console.log('userData ---> ', userData);
			return userData;
		} catch (error) {
			console.error('Error fetching user info:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}

	async getNotifications(page, search = '', params = {}, length = 10) {
		try {
			const response = await this.axiosInstance.get(
				'/notifications/get-notifications',
				{ page, length, search, ...params }
			);

			if (response.status !== 200) {
				throw new Error('Failed to fetch notifications');
			}
			return response.data;
		} catch (error) {
			console.error('Error fetching notifications:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}

	async markReadNotification(id) {
		try {
			const response = await this.axiosInstance.post(
				'/notifications/mark-read',
				{ id }
			);

			if (response.status !== 200) {
				throw new Error('Failed to mark read notification');
			}
			return response.data.data;
		} catch (error) {
			console.error('Error mark read notification:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}

	getRoleNameById(role_id) {
		return PermissionService.ALL_ROLES[role_id];
	}
}

export const userService = new UserService();
